import { ReactNode } from "react";
import { OrderActionType, DriverStatus, OrderStatus, OrderType, TeamStatus, UserRole, PaymentStatus, SourceChannel, ChatApp } from "./my-enum";

export interface Vehicle {
  id: number;
  vehicleID: string;
  vehiclename: string;
  peopleLimit: number;
  luggageSupporting: LuggageAccommodate[];
  totalLuggageLimit: number;
  //serviceFee: ServiceFee[];
  enabled: boolean;
}

export interface APIResult {
  statusCode: number;
  message: string;
  data: any;
}

export interface User {
  id: number;
  userId: string;
  displayName: string;
  email: string;
  authProvider?: string | null;
  roleString: string;
  jwtToken: string;
  refreshToken: string;
  lineAccessToken: string | null;
  tokenExpiry: Date | null;
  driver: Driver | null;
  team: Team;
  lastLogin: Date | null;
}

export interface Luggage {
  size: number;
  discription: string;
}


export interface LuggageAccommodate {
  luggage: Luggage;
  quantity: number;
}

export interface RegistLuggage {
  luggage: Luggage;
  quantity: number;
}

export type HeaderProps = {
  HeaderTitle: string;
  isShowRefresh: boolean;
  OnReturn: () => void;
  OnRefresh: () => void;
}

export interface PlaceAutocompleteProps {
  onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
}

export interface PlaceSelectProps {
  onPlaceSelect: (place: Place | undefined) => void;
}

export interface RideDatetimeSelectProps {
  onDatetimeSelect: (selectedDatetime: Date | null) => void;
  defaultDate: Date | void;
}

export interface OrderDisplayProps {
  order: Order;
  isShowDetail: boolean;
  userRole: UserRole;
  onOrderAction: (order: Order, actionType: OrderActionType) => void;
}

export interface FlightDepartureComponentProps {
  flightDeparture: FlightDeparture;
}

export interface FlightArrivalComponentProps {
  flightArrival: FlightArrival;
}

export interface PageBaseProps {
  header: ReactNode | undefined;
  content: ReactNode;
  showSide: boolean;
}

export interface Terminal {
  id: number;
  code: string;
  name: string;
}

export interface Place {
  id: string;
  name: string;
  address: string;
  country: string;
  firstLevel: string;
  secondLevel: string;
  thirdLevel: string;
  road: string;
}

export interface FlightSchedule {
  AirlineID: string;
  ScheduleStartDate: string;
  ScheduleEndDate: string;
  FlightNumber: string;
  DepartureAirportID: string;
  DepartureTime: string;
  ArrivalAirportID: string;
  ArrivalTime: string;
  Terminal: string;
}

export interface AirlineName {
  zh_tw: string;
  en: string;
}

export interface Airline {
  airlineID: string;
  airlineName: AirlineName;
  airlineIATA: string;
  airlineICAO: string;
  airlineEmail: string;
}


export interface Order {
  id: number;
  orderID: string;
  userID: string;
  userUID: number;
  orderType: OrderType;
  address: string;
  destinationAddress: string | null;
  terminal: string;
  rideTime: Date;
  estArriveTime: Date;
  flightNo: string;
  flightTime: Date | null;
  rideTimeValid: boolean;
  vehicleID: string;
  luggages: string;
  luggageNote: string;//TODO: rename to rideNote
  passengerName: string;
  passengerPhone: string;
  passengerID: string;
  passengerAdult: number;
  passengerBaby: number;
  driverUID: number;
  driver: Driver | null;
  rideFee: number;
  status: OrderStatus;
  createdAt: Date;
  completedAt: Date | null;
  teamCode: string;
  signatureFileName: string | null;
  rentalStartTime: Date | null;
  rentalEndTime: Date | null;
  paymentPaid: boolean;
  email: string | null;
  isAdminOrder: boolean;
  fromUserUID: number | null;
  driverCommission: string | null;
  relatedOrderID?: string | null;
  viaPoints: string[] | null;
  specialRequests: string[] | null;
  meetAndGreetDetails: string | null;
  supplierId: number | null;
  sourceChannel: SourceChannel | null;
  externalBookingNo: string | null;
  chatApp: ChatApp | null;
  chatId: string | null;
  assignedCarModel: string | null;
  isBlindOrder?: boolean;
}

export interface Driver {
  id: number;
  userID: string;
  userUID: number;
  idCardNo: string;
  bankID: string | null;
  bankAccount: string | null;
  address: string;
  currentMileage: number;
  carLicensePhoto: string | null;
  insurancePhoto: string | null;
  carCheckDate: Date | null;
  insuranceExpiryDate: Date | null;
  licenceFeeExpiryDate: Date | null;
  fuelTaxMarch: boolean
  fuelTaxJune: boolean
  fuelTaxSeptember: boolean
  fuelTaxDecember: boolean
  licenceTaxJune: boolean
  licenceTaxOctober: boolean
  driverName: string;
  licencePlateNumber: string;
  phoneNumber: string;
  vehicleID: string;
  carBrand: string;
  carModel: string;
  carColor: string;
  status: DriverStatus;
  team: Team;
  teamCode: string;
}

export interface FlightDeparture {
  flightDate: string;
  flightNumber: string;
  airlineID: string;
  departureAirportID: string;
  arrivalAirportID: string;
  scheduleDepartureTime: string;
  estimatedDepartureTime: string;
  departureRemark: string;
  terminal: string;
  gate: string | null;
  isCargo: boolean;
  checkCounter: string;
  updateTime: string;
}

export interface FlightArrival {
  flightDate: string,
  flightNumber: string;
  airlineID: string;
  departureAirportID: string;
  arrivalAirportID: string;
  scheduleArrivalTime: string;
  actualArrivalTime: string | null;
  estimatedArrivalTime: string;
  arrivalRemark: string;
  terminal: string;
  gate: string | null;
  isCargo: boolean;
  acType: string;
  baggageClaim: string;
  updateTime: string;
}

export interface Team {
  id: number;
  code: string;
  adminUserUID: number;
  name: string;
  address: string | null;
  phone: string | null;
  email: string | null;
  status: TeamStatus;
  createdAt: Date;
  updatedAt: Date | null;
  vehicleData: string | null;
  serviceFeeData: string | null;
  suburbanFeeData: string | null;
  domainName: string | null;
}

export interface ServiceBasicFee {
  city: string[], vehicleID: string, price: number, pickUpPrice: number, holidayPrice: number
}

export interface ServiceFee {
  //vehicleID: string; //經濟4人座
  //orderType: OrderType[]; //送機
  airportID: string; //桃園機場
  //city: string[]; //台北市
  //pickUpFee: number;
  basicPrice: ServiceBasicFee[]; //1100
  //  suburbanFee: SuburbanFee[] | undefined;
}

export interface SuburbanFeeData {
  city: string; //台北市
  airportID: string; //桃園機場
  suburbanFee: SuburbanFee[];
}

export interface SuburbanFee {
  city: string; //台北市
  region: string | undefined //文山區
  basicPrice: number; //300 either basic or farther
  fartherPrice: number; //200 either basic or farther
  fartherStreets: string[]; //指南路三段,老泉街26巷
}

export interface LINEAuthorizationResponse {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  scope: string;
  token_type: string;
}

export type Holiday = {
  date: string;
  week: string;
  isHoliday: boolean;
  description: string;
}

export type Question = {
  title: string;
  answer: string;
  publish_date: string;
}

export type Article = {
  documentId: string;
  title: string;
  slug: string;
  category: string | null;
  publishedAt: Date;
  updatedAt: Date;
  RichContent: string;
  cover: any | null;
}

export enum DateType {
  Working,
  Holiday,
  LastDayOfVacation
}

export type Payment = {
  id: number;
  orderID: string;
  amount: number;
  tapPayTradeID: string;
  merchantID: string;
  status: PaymentStatus;
  createdAt: Date;
  updatedAt: Date;
}

export type PayByPrimeResult = {
  order_number: string;
  success: boolean;
  need_3d: boolean;
  payment_url?: string;
}

// Email Verification Types
export interface EmailVerificationSendRequest {
  email: string;
  userId?: number;
}

export interface EmailVerificationSendResponse {
  message: string;
}

export interface EmailVerificationVerifyRequest {
  email: string;
  code: string;
}

export interface EmailVerificationVerifyResponse {
  message: string;
  isValid: boolean;
}

export interface EmailVerificationResult<T> {
  success: boolean;
  data: T;
  error?: string;
}

// ECPay Payment Types
export interface ECPayOrderParams {
  MerchantID: string;
  MerchantTradeNo: string;
  MerchantTradeDate: string;
  PaymentType: "aio";
  TotalAmount: number;
  TradeDesc: string;
  ItemName: string;
  ReturnURL: string;
  ChoosePayment: "Credit";
  CheckMacValue: string;
  EncryptType: 1;
  ClientBackURL?: string;
  ItemURL?: string;
  Remark?: string;
  OrderResultURL?: string;
  NeedExtraPaidInfo?: "Y" | "N";
  IgnorePayment?: string;
  PlatformID?: string;
  CustomField1?: string;
  CustomField2?: string;
  CustomField3?: string;
  CustomField4?: string;
  Language?: "ENG" | "KOR" | "JPN" | "CHI";
  Redeem?: "Y" | "N";
  UnionPay?: 0 | 1 | 2;
  MerchantMemberID?: string;
  BindingCard?: 0 | 1;
}

export interface ECPayConfig {
  merchantID: string;
  isProduction: boolean;
}

// ECPay Payment Result Types
export interface ECPayResult {
  MerchantID: string;
  MerchantTradeNo: string;
  StoreID?: string;
  RtnCode: number;
  RtnMsg: string;
  TradeNo: string;
  TradeAmt: number;
  PaymentDate: string;
  PaymentType: string;
  PaymentTypeChargeFee: number;
  TradeDate: string;
  SimulatePaid: 0 | 1;
  CustomField1?: string;
  CustomField2?: string;
  CustomField3?: string;
  CustomField4?: string;
  CheckMacValue: string;
}

// ECPay Refund Types
export interface RefundPaymentRequest {
  orderId: string;
  refundAmount?: number; // Optional: defaults to full amount
  refundReason?: string; // Optional
}

export interface ECPayRefundResponse {
  success: boolean;
  message: string;
  refundAmount?: number;
  tradeNo?: string;
  rtnCode?: number;
  errorCode?: number;
  errorMessage?: string;
  maintenanceWindow?: string;
}

export interface ECPayRefundRequest {
  MerchantID: string;
  MerchantTradeNo: string;
  TradeNo: string;
  Action: "R"; // R for Refund
  TotalAmount: number;
  PlatformID?: string;
  CheckMacValue: string;
}

export interface Supplier {
  id: number;
  code: string;
  name: string;
  phone?: string | null;
  email?: string | null;
  teamId: number;
  status: number;
  createdAt: Date;
}

export interface SupplierSelectProps {
  teamId: number;
  value: number | null;
  onChange: (supplierId: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
  block?: boolean;
}

export const SPECIAL_REQUESTS = [
  { label: '需要兒童座椅', value: 'child_seat' },
  { label: '請勿交談', value: 'no_talk' },
  { label: '輪椅協助', value: 'wheelchair' },
  { label: '寵物同行', value: 'pet_onboard' },
  { label: '禁煙車輛', value: 'non_smoking' },
  { label: '其他', value: 'other' }
];
